import React from "react";
import { Routes, Route } from "react-router-dom";

// layouts;
import Layout from "../layout/index";
import { AuthProtected, AccessRoute } from "./AuthProtected";
import { authProtectedRoutes, publicRoutes } from "./routes";
import { AuthContextProvider } from "../contexts/AuthContext"


const Index = () => {

  return (
    <Routes>
      <Route>
        {/* Public routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<AccessRoute>{route.component}</AccessRoute>}
            key={idx}
            exact={true}
          />
        ))}
      </Route>
      {/* ----------------------------------- */}
      <Route>
        {/* Auth protected routes */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthContextProvider >
                <AuthProtected>
                  <Layout>{route.component}</Layout>
                </AuthProtected>
              </AuthContextProvider>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default Index;
